import React, { useEffect, useContext } from 'react'
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';

import '../../../../style/css/rule.css'
import { routePrivacyPolicy } from '../../../../style/css/CmnStyle';
import { hpContext } from '../../HPContext'


// 利用規約
function TermOfService() {
  const { t, i18n } = useTranslation();

  const ReactGA = useContext(hpContext).ReactGA;

  const scrollHeadHeight = useContext(hpContext).scrollHeadHeight;
  const isWide = useContext(hpContext).isWide;


  useEffect(() => {
    // ログ：ページ
    ReactGA.event("pageRiyoukiyaku");
  }, [])


  return (
    <View style={{marginTop: scrollHeadHeight}}>

      <div className={isWide? 'wide-rule-wrap' : 'rule-wrap'}>

        <h1 className='rule-title'>{t('kiyaku.title')}</h1>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.title')}</h2>
          <p className='article-content'>{t('kiyaku.premise')}</p>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a1.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a1.l1')}</li>
              <li>{t('kiyaku.a1.l2')}</li>
              <li>{t('kiyaku.a1.l3')}</li>
              <li>{t('kiyaku.a1.l4')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a2.title')}</h2>
          <div className='article-content'>
            <p>{t('kiyaku.a2.premise')}</p>
            <ol className='article-ol'>
              <li>{t('kiyaku.a2.l1')}</li>
              <li>{t('kiyaku.a2.l2')}</li>
              <li>{t('kiyaku.a2.l3')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a3.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a3.l1')}</li>
              <li>{t('kiyaku.a3.l2')}</li>
              <li>
                {t('kiyaku.a3.l3.main')}
                <br />
                <div className='article-sub-list-wrap'>
                  <p>{t('kiyaku.a3.l3.sub1')}</p>
                  <p>{t('kiyaku.a3.l3.sub2')}</p>
                  <p>{t('kiyaku.a3.l3.sub3')}</p>
                  <p>{t('kiyaku.a3.l3.sub4')}</p>
                </div>
              </li>
              <li>
                {t('kiyaku.a3.l4.main')}
                <br />
                <div className='article-sub-list-wrap'>
                  <p>{t('kiyaku.a3.l4.sub1')}</p>
                  <p>{t('kiyaku.a3.l4.sub2')}</p>
                  <p>{t('kiyaku.a3.l4.sub3')}</p>
                  <p>{t('kiyaku.a3.l4.sub4')}</p>
                </div>
              </li>
              <li>{t('kiyaku.a3.l5')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a4.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a4.l1')}</li>
              <li>{t('kiyaku.a4.l2')}</li>
              <li>{t('kiyaku.a4.l3')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a5.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a5.l1')}</li>
              <li>{t('kiyaku.a5.l2')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a6.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>
                {t('kiyaku.a6.l1.main')}
                <br />
                <div className='article-sub-list-wrap'>
                  <p>{t('kiyaku.a6.l1.sub1')}</p>
                  <p>{t('kiyaku.a6.l1.sub2')}</p>
                  <p>{t('kiyaku.a6.l1.sub3')}</p>
                  <p>{t('kiyaku.a6.l1.sub4')}</p>
                  <p>{t('kiyaku.a6.l1.sub5')}</p>
                  <p>{t('kiyaku.a6.l1.sub6')}</p>
                </div>
              </li>
              <li>{t('kiyaku.a6.l2')}</li>
              <li>{t('kiyaku.a6.l3')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a7.title')}</h2>
          <div className='article-content'>
            <p>{t('kiyaku.a7.premise')}</p>
            <ol className='article-ol'>
              <li>{t('kiyaku.a7.l1')}</li>
              <li>{t('kiyaku.a7.l2')}</li>
              <li>{t('kiyaku.a7.l3')}</li>
              <li>{t('kiyaku.a7.l4')}</li>
              <li>{t('kiyaku.a7.l5')}</li>
              <li>{t('kiyaku.a7.l6')}</li>
              <li>{t('kiyaku.a7.l7')}</li>
              <li>{t('kiyaku.a7.l8')}</li>
              <li>{t('kiyaku.a7.l9')}</li>
              <li>{t('kiyaku.a7.l10')}</li>
              <li>{t('kiyaku.a7.l11')}</li>
              <li>{t('kiyaku.a7.l12')}</li>
              <li>{t('kiyaku.a7.l13')}</li>
              <li>{t('kiyaku.a7.l14')}</li>
              <li>{t('kiyaku.a7.l15')}</li>
              <li>{t('kiyaku.a7.l16')}</li>
              <li>{t('kiyaku.a7.l17')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a8.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>
                {t('kiyaku.a8.l1.main')}
                <br />
                <div className='article-sub-list-wrap'>
                  <p>{t('kiyaku.a8.l1.sub1')}</p>
                  <p>{t('kiyaku.a8.l1.sub2')}</p>
                  <p>{t('kiyaku.a8.l1.sub3')}</p>
                  <p>{t('kiyaku.a8.l1.sub4')}</p>
                  <p>{t('kiyaku.a8.l1.sub5')}</p>
                </div>
              </li>
              <li>{t('kiyaku.a8.l2')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a9.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a9.l1')}</li>
              <li>{t('kiyaku.a9.l2')}</li>
              <li>{t('kiyaku.a9.l3')}</li>
              <li>{t('kiyaku.a9.l4')}</li>
              <li>{t('kiyaku.a9.l5')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a10.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>
                {t('kiyaku.a10.l1').split('\n').map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </li>
              <li>{t('kiyaku.a10.l2')}</li>
              <li>{t('kiyaku.a10.l3')}</li>
              <li>{t('kiyaku.a10.l4')}</li>
              <li>{t('kiyaku.a10.l5')}</li>
              <li>{t('kiyaku.a10.l6')}</li>
              <li>{t('kiyaku.a10.l7')}</li>
              <li>{t('kiyaku.a10.l8')}</li>
              <li>{t('kiyaku.a10.l9')}</li>
              <li>{t('kiyaku.a10.l10')}</li>
              <li>{t('kiyaku.a10.l11')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a11.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a11.l1')}</li>
              <li>{t('kiyaku.a11.l2')}</li>
              <li>{t('kiyaku.a11.l3')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a12.title')}</h2>
          <div className='article-content'>
            <p>
              {t('kiyaku.a12.l1-1')}
              「
              <a href={routePrivacyPolicy} target='_blank'>{t('policy.title')}</a>
              」
              {t('kiyaku.a12.l1-2')}
            </p>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a13.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a13.l1')}</li>
              <li>{t('kiyaku.a13.l2')}</li>
              <li>{t('kiyaku.a13.l3')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a14.title')}</h2>
          <div className='article-content'>
            <p>{t('kiyaku.a14.l1')}</p>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a15.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a15.l1')}</li>
              <li>{t('kiyaku.a15.l2')}</li>
              <li>{t('kiyaku.a15.l3')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a16.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a16.l1')}</li>
              <li>{t('kiyaku.a16.l2')}</li>
              <li>{t('kiyaku.a16.l3')}</li>
              <li>{t('kiyaku.a16.l4')}</li>
              <li>{t('kiyaku.a16.l5')}</li>
              <li>
                {t('kiyaku.a16.l6.main')}
                <br />
                <div className='article-sub-list-wrap'>
                  <p>{t('kiyaku.a16.l6.sub1')}</p>
                  <p>{t('kiyaku.a16.l6.sub2')}</p>
                  <p>{t('kiyaku.a16.l6.sub3')}</p>
                </div>
              </li>
              <li>{t('kiyaku.a16.l7')}</li>
              <li>{t('kiyaku.a16.l8')}</li>
              <li>{t('kiyaku.a16.l9')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a17.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a17.l1')}</li>
              <li>{t('kiyaku.a17.l2')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a18.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a18.l1')}</li>
              <li>{t('kiyaku.a18.l2')}</li>
            </ol>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('kiyaku.a19.title')}</h2>
          <div className='article-content'>
            <ol className='article-ol'>
              <li>{t('kiyaku.a19.l1')}</li>
              <li>{t('kiyaku.a19.l2')}</li>
            </ol>
          </div>
        </div>

        <div className='article history-wrap'>
          <h3 className='history-title'>{t('kiyaku.history.title')}</h3>
          <ul className='history'>
            <li>{t('kiyaku.history.v1')}</li>
            <li>{t('kiyaku.history.v2')}</li>
          </ul>
        </div>

      </div>

    </View>
  );
}

export default TermOfService;